import { IndustriepartnerHttpService } from 'src/app/core/services/industriepartner-http.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { LocalSearchService } from './../../../core/services/local-search.service';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AngebotsListenHttpService } from 'src/app/core/services/angebots-listen-http.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { AngebotsVersionsListe } from 'src/app/shared/model';
import { AskDeleteComponent } from 'src/app/modals/ask-delete/ask-delete.component';

@Component({
  selector: 'app-angebotsversionslisten-index',
  templateUrl: './angebotsversionslisten-index.component.html',
  styleUrls: ['./angebotsversionslisten-index.component.scss']
})
export class AngebotsversionslistenIndexComponent implements OnInit {

  public angebotslistenFiltered = [];
  public angebotslisten = [];
  public loading = false;

  public search = new FormControl();

  constructor(private angebotsService: AngebotsListenHttpService, private authService: AuthService, private dialog: MatDialog, private snack: MatSnackBar, private indService: IndustriepartnerHttpService) { }

  ngOnInit(): void {
    this.loading = true;

    this.angebotsService.getAllAngebotsVersionslisten(this.indService.getAnbieterNr()).subscribe(res => {
      this.angebotslistenFiltered = res as [];
      this.angebotslisten = res as [];
      this.loading = false;
    }, err => {
      this.loading = false;
      console.log(err);
    });

    this.search.valueChanges.subscribe(val => {
      this.angebotslistenFiltered = LocalSearchService.search(this.angebotslisten, val);
    });
  }

  deleting = false;
    askDelete(avl: AngebotsVersionsListe) {
        this.dialog.open(AskDeleteComponent, {data: {
            title: 'Angebotsliste wirklich löschen?',
            body: 'Möchten Sie die Angebotsliste '+avl.listenName+' wirklich löschen?'
        }}).afterClosed().subscribe(res => {
            if(!res)
                return;
            // delete
            this.deleting = true;
            this.angebotsService.deleteListe(avl.id).subscribe(res => {
                this.deleting = false;
                this.snack.open('Angebotsliste wurde erfolgreich entfernt.', 'Erfolgreich', {panelClass: 'success-snackbar'});
                let d = this.angebotslisten;
                for(let i = this.angebotslisten.length-1; i >= 0; i--) {
                    let al = this.angebotslisten[i];
                    console.log(al);
                    if(al['id'] != avl.id)
                        continue;
                    d.splice(i, 1);
                }
                this.angebotslisten = [...d];
                this.angebotslistenFiltered = [...d];
            }, err => {
                this.deleting = false;
                console.log(err);
            })
        })
    }
}
